import { useState, useEffect } from 'react'

export const useFetchAllCashRegisters= ({marvarApi, dispatch, onLogout}) => {
    const [cashRegisters, setCashRegisters] = useState([])
    

    const [ execute, setExecute ] = useState(false)
    const executeFetchAllCashRegisters = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/caja`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
            fetchData()
                .then((resp) => {
                    const { data } = resp
                    setCashRegisters(data)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
    }, [execute])

    return { cashRegisters, executeFetchAllCashRegisters }
}

export const useFetchAllBanks= ({marvarApi, dispatch, onLogout}) => {
    const [banks, setBanks] = useState([])
    

    const [ execute, setExecute ] = useState(false)
    const executeFetchAllBanks = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/banco`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
            fetchData()
                .then((resp) => {
                    const { data } = resp

                    setBanks(data)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
    }, [execute])

    return { banks, executeFetchAllBanks }
}

export const useFetchAllDeposits= ({marvarApi, dispatch, onLogout, Forms}) => {
    const [deposits, setDeposits] = useState([])
    const [loadingFetchDeposits, seteLoadingFetchDeposits ] = useState(false) //estado para animacion de carga
    
    const {FormRequestGlobal:{formState}} = Forms


    const [ execute, setExecute ] = useState(false)
    const executeFetchAllDeposits = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        const _data = {
            idcredito: formState.idcredito,
            idgestiontipo: formState.idgestiontipo,
            idgestion: formState.idgestion
        }
        try {
            const response = await marvarApi.post(`/vehicle/mgmt-managements/get-all-deposit`, _data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if((formState.idcredito > 0)&&(formState.idgestiontipo > 0) ){
            seteLoadingFetchDeposits(true)
            fetchData()
                .then((resp) => {
                    setDeposits(resp.data)
                    seteLoadingFetchDeposits(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    seteLoadingFetchDeposits(false)
                })
        }
    }, [execute, formState.idcredito, formState.idgestiontipo, formState.idgestion])

    return { deposits, loadingFetchDeposits, executeFetchAllDeposits }

}

export const useFetchAllTypeManagements = ({marvarApi, dispatch, onLogout}) => {
    const [typeManagements, setTypeManagements] = useState([])
    const [loadingFetchTypeManagements, setLoadingFetchTypeManagements ] = useState(false) //estado para animacion de carga
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllTypeManagements = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/vehicle/mgmt-managements/type-managements`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchTypeManagements(true)
        fetchData()
            .then((resp) => {
                setTypeManagements(resp.data)
                setLoadingFetchTypeManagements(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchTypeManagements(false)
            })
    }, [execute])

    return { typeManagements, loadingFetchTypeManagements, executeFetchAllTypeManagements }

}

export const useFetchAllContracts = ({marvarApi, dispatch, onLogout}) => {
    const [contracts, setContracts] = useState([])
    const [loadingFetchContracts, setLoadingFetchContracts ] = useState(false) //estado para animacion de carga
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllContracts = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/vehicle/mgmt-managements/veh-credits`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchContracts(true)
        fetchData()
            .then((resp) => {
                setContracts(resp.data)
                setLoadingFetchContracts(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchContracts(false)
            })
    }, [execute])

    return { contracts, loadingFetchContracts, executeFetchAllContracts }

}


export const useFetchInfoContract = ({marvarApi, dispatch, onLogout, Forms, Helpers}) => {

    const {FormRequestGlobal} = Forms
    const {setFormState, formState} = FormRequestGlobal

    const {numberFormatter} = Helpers

    const [loadingFetchContract, setLoadingFetchContract ] = useState(false) //estado para animacion de carga
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoContract = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        if (formState.idcredito > 0) {
            try {
                const response = await marvarApi.get(`/vehicle/common/get-application-ID/${formState.idcredito}`)
                return response.data
            } catch (e) {
                console.log(e)
            }
        }else{
            setLoadingFetchContract(true)
        }

    }

    useEffect(() => {
        setLoadingFetchContract(true)
        if (formState.idcredito > 0) {
            fetchData()
                .then((resp) => {
                    const { data } = resp

                    const interes_anual = parseFloat(data.interes)*100*12

                    setFormState((prevState) => ({
                        ...prevState,
                        credito_dia_pago: data.credito_dia_pago || '',
                        dpi: data.dpi || '',
                        cliente: data.cliente || '',
                        telefono: data.telefono || '',
                        vehiculo: data.vehiculo || '',  
                        total_cuota: numberFormatter.format(data.total_cuota) || '',
                        cargos_extras_total: data.cargos_extras_total || 0, 
                        deposito_total: data.deposito_total || 0,
                        seguro: numberFormatter.format(data.seguro || 0),
                        fecha_ren_seguro: data.fecha_ren_seguro || '',
                        fecha_fin_contrato: data.fecha_fin_credito || '',
                        check_requerimiento_gps: data.check_retiro_gps || 0, 
                        check_requerimiento_seguro: data.check_cancelacion_seguro || 0,
                        check_requerimiento_solvent: (data.total_pagar<=0),
                        costo_retiro_gps: data.costo_retiro_gps || 0,
                        costo_finiquito: data.costo_finiquito || 0,
                        aprobacion_fecha: data.aprobacion_fecha,
                        plazo: data.plazo,
                        monto_venta: data.monto_venta,
                        saldo_financiar: data.saldo_financiar,
                        interes: parseFloat(data.interes)*100,
                        gps: numberFormatter.format(data.gps || 0),
                        otros: numberFormatter.format(data.otros || 0),
                        monto_enganche: data.monto_enganche,
                        cuota_niv: data.cuota_niv,
                        costo_finiquito: data.costo_finiquito,
                        fecha_finalizacion: data.fecha_fin_credito,

                        clean_gps: data.gps,
                        clean_seguro: data.seguro,
                        clean_otros: data.otros,

                        interes_total: numberFormatter.format(interes_anual),
                        // Si hay una gestion cargada, sus valores (REF) no deben ser pisados por los del credito original
                        ...(prevState.idgestion > 0 ? {
                            interes: prevState.interes,
                            interes_total: prevState.interes_total,
                            gps: prevState.gps,
                            seguro: prevState.seguro,
                            otros: prevState.otros,
                            clean_gps: prevState.clean_gps,
                            clean_seguro: prevState.clean_seguro,
                            clean_otros: prevState.clean_otros,
                        } : {}),
                    }))
                    setLoadingFetchContract(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute, formState.idcredito    ])

    return { loadingFetchContract, executeFetchInfoContract }

}

export const useFetchInfoObservations = ({marvarApi, dispatch, onLogout, Forms}) => {

    const {FormRequestGlobal:{formState}} = Forms

    const [observations, setObservations] = useState([])
    const [loadingFetchObservations, setLoadingFetchObservations ] = useState(false) //estado para animacion de carga
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllObservations = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        if (formState.idgestion > 0) {
            try {
                const response = await marvarApi.get(`/vehicle/common/log-management/${formState.idgestion}`)
                return response.data
            } catch (e) {
                console.log(e)
            }
        }else{
            setLoadingFetchObservations(true)
        }

    }

    useEffect(() => {
        setLoadingFetchObservations(true)
        if (formState.idcredito > 0) {
            fetchData()
                .then((resp) => {
                    setObservations(resp)
                    setLoadingFetchObservations(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute, formState.idgestion])

    return { observations, loadingFetchObservations, executeFetchAllObservations }

}

export const useFetchInfoManagement = ({marvarApi, location, globalStates, dispatch, paramsURL, onLogout, Forms, Helpers}) => {

    const { idgestion } = paramsURL

    const { pathname } = location
    const urlWithoutParam = pathname.split('/')[2]; //El segundo fragmento de la URL
    const {setShowFormContract, setFormOpeningMode} = globalStates

    const {numberFormatter} = Helpers


   
    const {FormRequestGlobal} = Forms
    const {setFormState} = FormRequestGlobal

    // 1. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchManagement = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/common/management/${idgestion}`)
            console.log('[useFetchData][useFetchInfoManagement] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(idgestion > 0){
            fetchData()
                .then(async (resp) => {
                    const { data } = resp
                    if(data.length>0){
                        if(urlWithoutParam==='edit') await setFormOpeningMode('EDITABLE')
                        if(urlWithoutParam==='info') await setFormOpeningMode('READONLY')

                        const {gestion_gps, gestion_seguro, gestion_otros, gestion_cuota_niv} =  data[0]

                        const costo_total = (parseFloat(gestion_gps) + parseFloat(gestion_seguro) + parseFloat(gestion_otros) + parseFloat(gestion_cuota_niv))

                        setFormState((prevState) => ({
                            ...prevState,
                            idgestion : data[0].idgestion || '',
                            idcredito : data[0].idcredito || '',
                            idgestiontipo : data[0].idgestiontipo || '',
                            vehiculo : data[0].vehiculo || '',
                            cliente : data[0].cliente || '',
                            dpi : data[0].dpi || '',
                            telefono : data[0].telefono || '',
                            credito_dia_pago : data[0].credito_dia_pago || '',
                            total_cuota : data[0].total_cuota || '',
                            gestion_nuevo_dia_pago : data[0].gestion_nuevo_dia_pago || '',
                            gestion_descripcion : data[0].gestion_descripcion || '',
                            aprobacion_check : data[0].aprobacion_check || '',
                            aprobacion_fecha : data[0].aprobacion_fecha || '',
                            monto_devolucion : data[0].monto_devolucion || '',
                            cargos_extras_total : data[0].cargos_extras_total || 0,
                            deposito_total : data[0].deposito_total || 0,
                            fecha_ren_seguro: data[0].fecha_ren_seguro || '',
                            fecha_fin_contrato: data[0].fecha_fin_contrato || '',
                            total_seguro: data[0].gestion_total_seguro || 0,
                            seguro: data[0].gestion_cuota_seguro || 0,
                            check_seguro: !data[0].check_seguro || 0,
                            check_carta: data[0].check_seguro || 0,
                            document_path: data[0].document_path || '',
                            gestion_nuevo_idcredito: data[0].gestion_nuevo_idcredito ? `VH${data[0].gestion_nuevo_idcredito}` : '',

                            interes: data[0].gestion_interes || 0,
                            interes_total: numberFormatter.format(data[0].gestion_interes * 12) || 0,
                            gps: numberFormatter.format(data[0].gestion_gps || 0),
                            seguro: numberFormatter.format(data[0].gestion_seguro || 0),
                            otros: numberFormatter.format(data[0].gestion_otros || 0),
                            nuevo_plazo: data[0].gestion_plazo || 0,
                            plazo_anios: numberFormatter.format(data[0].gestion_plazo / 12) || 0,
                            nuevo_cuota_niv: numberFormatter.format(data[0].gestion_cuota_niv || 0),
                            saldo_financiado: numberFormatter.format(data[0].gestion_saldo_financiado || 0),
                            clean_saldo_financiado: parseFloat(data[0].gestion_saldo_financiado) || 0,
                            nuevo_total_cuota: numberFormatter.format(costo_total),
                            clean_gps: parseFloat(data[0].gestion_gps) || 0,
                            clean_seguro: parseFloat(data[0].gestion_seguro) || 0,
                            clean_otros: parseFloat(data[0].gestion_otros) || 0,
                            clean_nuevo_cuota_niv: parseFloat(data[0].gestion_cuota_niv) || 0,
                            clean_nuevo_total_cuota: costo_total || 0,

                            transactions: data[0].transactions,

                            exoneraciones: data[0].exoneraciones || [],
                            porcentaje_exoneracion: data[0].exoneraciones?.[0]?.porcentaje_exonerado || 0,
                            total_exoneracion: numberFormatter.format(data[0].exoneracion_mora || 0),
                        }))

                        setShowFormContract(true)
                    } 
                })
            }
    }, [execute])

    return { executeFetchManagement }
}

export const useFetchTotalInsurance = ({marvarApi, dispatch, onLogout, Forms, Helpers, globalStates}) => {

    const {FormRequestGlobal} = Forms
    const {setFormState, formState} = FormRequestGlobal

    const {numberFormatter, getCurrentDate} = Helpers

    const {modalOpeningMode} = globalStates
    const _data = {
        idcredito: formState.idcredito,
        fecha_actual: getCurrentDate(),
    } 
    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoContract = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        if (formState.idcredito > 0) {
            try {
                const response = await marvarApi.post(`/vehicle/mgmt-managements/total-insurance`, _data)
                return response.data
            } catch (e) {
                console.log(e)
            }
        }
        
    }

    useEffect(() => {
        if (modalOpeningMode!=='READONLY' && (formState.idcredito>0) && (formState.idgestiontipo>0)) {
            
            fetchData()
                .then((resp) => {
                    const { data } = resp
                    const total_seguro = parseFloat(data[0].total_seguro)
                    setFormState((prevState) => ({
                        ...prevState,
                        total_seguro: numberFormatter.format(total_seguro) || '',
                    }))
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute, formState.idcredito, formState.idgestiontipo])

    return { executeFetchInfoContract }
}

export const useFetchInfoDeposit = ({marvarApi, dispatch, onLogout, Forms}) =>{

    // Formateador de números
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });

    const { FormDeposit:{setFormState} } = Forms

    // 1. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({})

    // 2. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoDeposit = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/mgmt-managements/get-deposit-by-ID/${paramsToSearch.idmovimiento}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idmovimiento > 0 ){
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idmovimiento: data.idmovimiento || '',
                        idcaja : data.idcaja || '',
                        idbanco : data.idbanco || '',
                        boleta_numero : data.boleta_numero || '',
                        boleta_foto_path : data.boleta_foto_path || '',
                        boleta_foto_originalname : data.boleta_foto_originalname || '',
                        aprobacion_referencia_ach : data.aprobacion_referencia_ach || '',
                        aprobacion_observaciones : data.aprobacion_observaciones || '',
                        aprobacion_check : data.aprobacion_check || '',
                        deposito_fecha : data.deposito_fecha || '',
                        deposito_moneda : data.deposito_moneda || '',
                        deposito_observaciones : data.deposito_observaciones || '',
                        deposito_tipo_cambio : data.deposito_tipo_cambio || '',
                        movimiento_tipo : data.movimiento_tipo || '',
                        
                        deposito_monto : numberFormatter.format(data.deposito_monto) || '',
                        deposito_quetzales : numberFormatter.format(data.deposito_quetzal) || '',
                        deposito_dolares : numberFormatter.format(data.deposito_dolares) || '',
                    }))

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute])

    return { setParamsToSearch, executeFetchInfoDeposit }
}

export const useFetchDebtsSummary = ({marvarApi, dispatch, onLogout, Forms, Helpers}) =>{
    
    const { FormRequestGlobal } = Forms
    const { formState, setFormState } = FormRequestGlobal
    const {numberFormatter, getCurrentDate}= Helpers

    const fecha_actual = getCurrentDate()

    // 1. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchDebtsSummary = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {

        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.post(`/vehicle/common/get-debts-summary/${formState.idcredito}`, {fecha_actual: fecha_actual})
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idcredito > 0){
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    if(resp.title==='OK'){
                        const { rows } = resp
                        const total_deuda = parseFloat(rows[0].total_capital_restante) + parseFloat(rows[0].total_gastos_juridicos) + parseFloat(rows[0].total_gastos_admin)

                        setFormState((prevState) => ({
                            ...prevState,
                            suma_dias_atraso_totales: rows[0].suma_dias_atraso_totales,
                            suma_total_pagar: numberFormatter.format(rows[0].total_capital_restante),
                            total_gastos_juridicos: numberFormatter.format(rows[0].total_gastos_juridicos),
                            total_gastos_admin: numberFormatter.format(rows[0].total_gastos_admin),
                            total_deuda_credito: numberFormatter.format(total_deuda),
                            // En una gestion existente el monto a refinanciar es el guardado en la
                            // gestion; la deuda viva solo lo precarga al crear una gestion nueva
                            // (capital + gastos; al llegar la mora se actualiza con el total con mora).
                            ...(prevState.idgestion > 0 ? {} : {
                                saldo_financiado: numberFormatter.format(total_deuda),
                                clean_saldo_financiado: total_deuda,
                            }),

                        }))

                        marvarApi.get(`/vehicle/mgmt-managements/mora-pendiente/${formState.idcredito}?incluir_pendientes=1`)
                            .then(({ data }) => {
                                const mora = (data.rows || []).reduce((acc, row) => acc + (parseFloat(row.mora_pendiente) || 0), 0)
                                setFormState((prevState) => ({
                                    ...prevState,
                                    mora_pendiente: numberFormatter.format(mora),
                                    total_deuda_mora: numberFormatter.format(total_deuda + mora),
                                    // Al crear una gestion el monto a refinanciar se precarga con el total
                                    // con mora; en una gestion existente se respeta el monto guardado.
                                    ...(prevState.idgestion > 0 ? {} : {
                                        saldo_financiado: numberFormatter.format(total_deuda + mora),
                                        clean_saldo_financiado: total_deuda + mora,
                                    }),
                                }))
                            })
                            .catch(e => console.log(e, '________ERROR MORA'))
                    }
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute, formState.idcredito, formState.idgestiontipo])

    return { executeFetchDebtsSummary }
}

export const useFetchTransactionsByCredit = ({marvarApi, dispatch, onLogout, Forms}) => {

    const { FormRequestGlobal } = Forms
    const { formState } = FormRequestGlobal

    const _defaultParams = {
        idcredito: ''
    }
    const [ paramsToSearch, setParamsToSearch ] = useState(_defaultParams)
    const [ dataTransactions, setDataTransactions ] = useState([])
    const [ loadingFetchTransactions , setLoadingFetchTransactions ] = useState(false) //estado para animacion de carga
    
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/mgmt-managements/fetch-transactions-by-credit/${formState.idcredito}`)
            // console.log('[useFetchData][useFetchTransactionsByCredit] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchTransactions(true)
        // if (paramsToSearch.idcredito > 0 && paramsToSearch.idcredito !== '') {
        if (formState.idcredito !== '' && formState.idcredito > 0) {
        // if(formState.idcredito > 0){
            fetchData()
                .then((resp) => {
                    setDataTransactions(resp.rows)
                    setLoadingFetchTransactions(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchTransactions(false)
                })
        }
    }, [execute, formState.idcredito, formState.idgestiontipo])

    return { dataTransactions, loadingFetchTransactions, executeFetch, setParamsToSearch }

}


export const useFetchCreditPayments = ({marvarApi, dispatch, onLogout, Forms, Helpers}) => {

    const { FormRequestGlobal } = Forms
    const { formState } = FormRequestGlobal

    const { getCurrentDate } = Helpers

    const _defaultParams = {
        idcredito: ''
    }
    const [ paramsToSearch, setParamsToSearch ] = useState(_defaultParams)
    const [ dataCreditPayments, setDataCreditPayments ] = useState([])
    const [ loadingFetchCreditPayments , setLoadingFetchCreditPayments ] = useState(false) //estado para animacion de carga
    
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const _body = {
                currentDate: getCurrentDate()
            }
            const response = await marvarApi.post(`vehicle/mgmt-payments/${formState.idcredito}`, _body)
            console.log('[useFetchData][useFetchCreditPayments] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        // 14 gestión de pago retroactivo
        if (formState.idcredito !== '' && formState.idcredito > 0 && parseInt(formState.idgestiontipo, 10) === 16) {
            setLoadingFetchCreditPayments(true)
            fetchData()
                .then((resp) => {
                    setDataCreditPayments(resp.data)
                    setLoadingFetchCreditPayments(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchCreditPayments(false)
                })
        }
    }, [execute, formState.idcredito, formState.idgestiontipo])

    return { dataCreditPayments, loadingFetchCreditPayments, executeFetch, setParamsToSearch }

}

export const useFetchTransactionsByPayment = ({marvarApi, dispatch, onLogout, Forms}) => {

    const { FormRequestGlobal } = Forms
    const { formState, setFormState } = FormRequestGlobal

    const _defaultParams = {
        idpago: ''
    }
    const [ paramsToSearch, setParamsToSearch ] = useState(_defaultParams)
    const [ dataTransactions, setDataTransactions ] = useState([])
    const [ loadingFetchTransactionsByPayment , setLoadingFetchTransactionsByPayment ] = useState(false) //estado para animacion de carga
    
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/mgmt-payments/get-deposit/${paramsToSearch.idpago}`)
            // console.log('[useFetchData][useFetchTransactionsByPayment] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (paramsToSearch.idpago !== '' && paramsToSearch.idpago > 0) {
            setLoadingFetchTransactionsByPayment(true)
            fetchData()
                .then((resp) => {
                    setDataTransactions(resp.data)
                    setFormState((prevState) => ({
                        ...prevState,
                        // transactions: resp.data
                        transactions: resp.data.map((item) => ({
                            ...item,
                            oldRecord: true
                        })),
                    }))
                    setLoadingFetchTransactionsByPayment(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchTransactionsByPayment(false)
                })
        }
    }, [execute])

    return { dataTransactions, loadingFetchTransactionsByPayment, executeFetch, setParamsToSearch }

}

export const useFetchSpecificRetroTransaction = ({marvarApi, dispatch, onLogout, Forms}) =>{

    // Formateador de números
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });

    const { FormDeposit:{setFormState} } = Forms

    const _defaultParams = {
        idmovimiento: ''
    }

    // 1. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState(_defaultParams)

    // 2. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/credits/common/fetch-specific-retro-transaction/${paramsToSearch.idmovimiento}`)
            console.log('[useFetchData][useFetchSpecificRetroTransaction] response.data', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idmovimiento !== '' ){
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idmovimiento: data[0].idmovimiento || '',
                        idcaja : data[0].idcaja || '',
                        idbanco : data[0].idbanco || '',
                        boleta_numero : data[0].boleta_numero || '',
                        boleta_foto_path : data[0].boleta_foto_path || '',
                        boleta_foto_originalname : data[0].boleta_foto_originalname || '',
                        aprobacion_referencia_ach : data[0].aprobacion_referencia_ach || '',
                        aprobacion_observaciones : data[0].aprobacion_observaciones || '',
                        aprobacion_check : data[0].aprobacion_check || '',
                        deposito_fecha : data[0].deposito_fecha || '',
                        deposito_moneda : data[0].deposito_moneda || '',
                        deposito_observaciones : data[0].deposito_observaciones || '',
                        deposito_tipo_cambio : data[0].deposito_tipo_cambio || '',
                        movimiento_tipo : data[0].movimiento_tipo || '',
                        
                        deposito_monto : numberFormatter.format(data[0].deposito_monto) || '',
                        deposito_quetzales : numberFormatter.format(data[0].deposito_quetzal) || '',
                        deposito_dolares : numberFormatter.format(data[0].deposito_dolares) || '',
                    }))

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute])

    return { setParamsToSearch, executeFetch }
}

export const useFetchMoraPendienteByCredit = ({ marvarApi, dispatch, onLogout, Forms }) => {

    const { FormRequestGlobal } = Forms
    const { formState } = FormRequestGlobal

    const [dataMoraPendiente, setDataMoraPendiente] = useState([])
    const [loadingFetchMoraPendiente, setLoadingFetchMoraPendiente] = useState(false) //estado para animacion de carga

    const [execute, setExecute] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/mgmt-managements/mora-pendiente/${formState.idcredito}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchMoraPendiente(true)
        if (formState.idcredito !== '' && formState.idcredito > 0) {
            fetchData()
                .then((resp) => {
                    setDataMoraPendiente(resp.rows)
                    setLoadingFetchMoraPendiente(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchMoraPendiente(false)
                })
        }
    }, [execute, formState.idcredito, formState.idgestiontipo])

    return { dataMoraPendiente, loadingFetchMoraPendiente, executeFetch }

}